<cu-dynamic-page-layout [page]="page" [flow]="flow">
  <div page-body *ngIf="dontShowPageOnLogin()">
    
    <h2 class="bl-font-weight--900 bl-flex--auto bl-font-color--black bl-font-size--32 bl-text-align--center bl-width--100"> {{'ola-interstitial/heading'|dictionary}} </h2>
    <div class="bl-margin-bottom--16 bl-margin-x--0 bl-margin-x-sm--48">

      <div class="bl-margin-bottom--16 bl-margin-x--0 bl-margin-x-sm--48 bl-padding-x--0 bl-padding-x-sm--48">
        <div class="bl-check-wrap bl-margin-top--4 bl-margin-bottom--8 bl-block-module bl-no-body bl-block-module bl-no-body bl-padding-x--16 
        bl-padding-y--16 bl-border-radius--0" *ngFor="let interestial of interestialOptions; let i = index;">
          <input type="radio" id="ola-consumer-interestial-{{i}}" [value]="interestial.title" name="ola-consumer-interestial"
           [checked]="interestial.selected" (change)="setValue(i)">
          <label class="bl-label" for="ola-consumer-interestial-{{i}}">{{interestial.title}}</label>
        </div>
      </div>

      <div class="bl-display--flex bl-flex-flow--wrap ww-flex-flow-sm--nowrap bl-flex-direction--column-reverse bl-margin-x-sm--48 bl-margin-x--0 bl-padding-x--0 bl-padding-x-sm--48">
        <button class="bl-button bl-width--100" type="button" id="go-to-ext-registration-button" (click)="gotToOLANextPage()">
          <span class="loading-text">{{'ola-interstitial/continue'|dictionary}}</span>
        </button>
      </div>
    </div>
  </div>    
</cu-dynamic-page-layout>